import { Box, Grid } from "@mantine/core";

import { gridResponsive } from "../functions";

import type { PlanCard } from "@/types/plans";
import type { FC } from "react";

interface ColProps {
  card: PlanCard;
  index: number;
  children: React.ReactNode;
}

export const Col: FC<ColProps> = ({ card, index, children }) => {
  const grid = gridResponsive();

  return (
    <Grid.Col key={`${card.title}_KEY_` + index} span={grid}>
      <Box
        w="100%"
        mx="auto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
        }}
      >
        {children}
      </Box>
    </Grid.Col>
  );
};
